import React, { useState, memo } from "react";
import { Text, View, TouchableHighlight, Image } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import HomeProfile from "./HomeProfile";
import { userData } from "../../utility/types/userTypes";
import HomeActionsComponent from "./HomeActionsComponent";
import Tooltip from "react-native-walkthrough-tooltip";
import ImageComponent from "../ImageComponent";
import { AppImages } from "../../utility/AppImages";
import { TouchableOpacity } from "react-native-gesture-handler";
import { useTooltips } from "../../context/WalkthroughContext";
import { useAuthProvider } from "../../context/AuthContext";
import CreateEventComponent from "./CreateEventComponent";
import Separator from "../Separator";
import YourHomeTooltip from "../walk-through-common-components/homeScreenTooltips/YourHomeTooltip";
import CreateEventWalkthrough from "../walk-through-common-components/homeScreenTooltips/CreateEventWalkthrough";
import { useNavigation } from "@react-navigation/native";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { navigateToScreen } from "../../utility/NavigationHelper";
type HomeHeaderProps = {
  userData: userData;
  isMyEvents: boolean;
  setIsMyEvents: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEventTypeModal: React.Dispatch<React.SetStateAction<boolean>>;
  userImage?: string;
};

const HomeHeader: React.FC<HomeHeaderProps> = ({
  userData,
  isMyEvents,
  setIsMyEvents,
  setShowEventTypeModal,
}) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const isMobile =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  return (
    <View
      style={{
        marginBottom: 10,
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "3.5%"
            : 0,
      }}
    >
      <YourHomeTooltip
        content={
          <Text
            style={[
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? AppFontStyle.BOLD_ANYBODY_18
                : AppFontStyle.BOLD_ANYBODY_32,
              {
                color: AppColors.white,
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
              },
            ]}
          >
            Home
          </Text>
        }
      />

      <View style={{ flexDirection: "row", gap: 10, alignItems: "center" }}>
        {/* Go Live Button */}
        {/* Go Live Button - Hidden on Mobile */}
        {!isMobile && (
          <TouchableOpacity
            onPress={() =>
              navigateToScreen(navigation, AppScreens.StreamerGoLive)
            }
            style={{
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 10,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              paddingVertical: 12,
              paddingHorizontal: 24,
              gap: 8,
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_17,
                {
                  color: AppColors.white,
                },
              ]}
            >
              Go Live
            </Text>
          </TouchableOpacity>
        )}

        <CreateEventWalkthrough
          isMyEvents={isMyEvents}
          setIsMyEvents={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
          userData={userData}
        />
      </View>
    </View>
  );
};

export default memo(HomeHeader);
